import React from 'react'
import { TouchableOpacity, View } from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'

interface cardProps {
  children?: React.ReactNode
  action?: any
  narrow?: boolean
  style?: {
    [key: string]: any
  }
}

const Card = ({
  children,
  action,
  narrow = false,
  style
}: cardProps): JSX.Element => {
  return action ? (
    <TouchableOpacity
      onPress={action}
      style={[
        globalStyles.card,
        narrow && globalStyles.cardNarow,
        globalStyles.shadowPop,
        narrow ? globalStyles.mb2 : globalStyles.mb4
      ]}
    >
      {children}
    </TouchableOpacity>
  ) : (
    <View
      style={[
        globalStyles.card,
        narrow && globalStyles.cardNarow,
        globalStyles.shadowPop,
        narrow ? globalStyles.mb2 : globalStyles.mb4,
        { ...style }
      ]}
    >
      {children}
    </View>
  )
}

export default Card
